import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const InscriptionListPage = () =>
    import ('@modules/inscription/components/inscription-list-page.vue');
const InscriptionFormPage = () =>
    import ('@modules/inscription/components/inscription-form-page.vue');
const InscriptionViewPage = () =>
    import ('@modules/inscription/components/inscription-view-page.vue');
const InscriptionImporterPage = () =>
    import ('@modules/inscription/components/inscription-importer-page.vue');

export default [{
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [{
            name: 'inscriptionList',
            path: '/inscription/list',
            component: InscriptionListPage,
            meta: {
                auth: true,
                permission: Permissions.values.inscriptionView,
            },
        },
        {
            name: 'inscriptionNew',
            path: '/inscription/list/new',
            component: InscriptionFormPage,
            meta: {
                auth: true,
                permission: Permissions.values.inscriptionCreate,
            },
        },
        {
            name: 'inscriptionImporter',
            path: '/inscription/list/import',
            component: InscriptionImporterPage,
            meta: {
                auth: true,
                permission: Permissions.values.inscriptionImport,
            },
        },
        {
            name: 'inscriptionEdit',
            path: '/inscription/list/:id/edit',
            component: InscriptionFormPage,
            meta: {
                auth: true,
                permission: Permissions.values.inscriptionEdit,
            },
            props: true,
        },
        {
            name: 'inscriptionView',
            path: '/inscription/list/:id',
            component: InscriptionViewPage,
            meta: {
                auth: true,
                permission: Permissions.values.inscriptionView,
            },
            props: true,
        },
    ],
}, ];